import {Injectable} from '@angular/core';
import {ToolsService} from './tools.service';

@Injectable()
export class TitleBuilderService {
  constructor(private tools: ToolsService) {}

  public CreateServiceTitle(
    serviceName: string,
    careproviderName: string,
    cityName: string,
    split?: boolean
  ): string {
    const title: string[] = [];
    if (this.tools.isNil(careproviderName)) {
      careproviderName = 'saknas';
    }
    if (this.tools.isNil(cityName)) {
      cityName = 'saknas';
    }
    title.push(serviceName);
    if (split === true) {
      title.push('<br><span>');
    }
    title.push('hos');
    title.push(careproviderName);
    if (careproviderName.toLowerCase().indexOf(cityName.toLowerCase()) < 0) {
      title.push('i');
      title.push(cityName);
    }
    if (split === true) {
      title.push('</span>');
    }
    return title.join(' ');
  }

  public CreateCareproviderTitle(
    careproviderName: string,
    cityName: string,
    addOnName?: string
  ): string {
    const title: string[] = [];
    if (this.tools.isNil(careproviderName)) {
      careproviderName = 'saknas';
    }
    if (this.tools.isNil(cityName)) {
      cityName = 'saknas';
    }
    title.push(careproviderName);
    if (careproviderName.toLowerCase().indexOf(cityName.toLowerCase()) < 0) {
      title.push('i');
      title.push(cityName);
    }
    if (!this.tools.isNil(addOnName) && addOnName !== '') {
      title.push('-');
      title.push(addOnName);
    }
    return title.join(' ');
  }
}
